import { AVO_EVENT_NAMES } from "avo/eventNames";
import React, { useContext, useState } from "react";
import { sendEventUsingAvo } from "./events";

interface IPtlSignupState {
    sendEvent: (clickedOn:string) => void;
    getFromPage: () => string | null;
};

const PtlSignupContext = React.createContext({} as IPtlSignupState);

const PtlSignupProvider = ({ children }: any) => {

    const sendEvent = (clickedOn: string) => {
        sendEventUsingAvo({
          eventName: AVO_EVENT_NAMES.interactedLoginScreen,
          props: {
            clickedOn
          }
        })
      }

    const getFromPage = () => {
    if (window.location.hash.includes('?')) {
        const queryString = window.location.hash.split('?')[1];
        const urlParams = new URLSearchParams(queryString);
        const fromPage = urlParams.get('fromPage');
        if (fromPage) {
        return decodeURIComponent(fromPage);
        }
    }
    return null;
    }

    const PtlSignupState: IPtlSignupState = {
        sendEvent,
        getFromPage,
    };
    return (
        <PtlSignupContext.Provider value={PtlSignupState}>
            { children } 
        </PtlSignupContext.Provider>
    );
}

export const usePtlSignupState = () => {
    const context = useContext(PtlSignupContext);
    if (!context) {
        throw Error(`Use ${usePtlSignupState.name} in ${PtlSignupContext.displayName}`);
    }
    return context;
};

export default PtlSignupProvider;